import "regenerator-runtime/runtime";
import _asyncToGenerator from "F:/openy-admin-all/openy-wxms-web2026-07-24-2/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import { parseTime, cleanSpelChar } from '@/utils/index';
import { getMiniMessage as _getMiniMessage, loadH5Info } from "@/api/mini";
import { getSessionStorage, setSessionStorage } from '@/utils/get-or-set-cookie';
var state = {
  active: getSessionStorage("active"),
  activeWeapp: 0,
  miniMessage: {},
  applyMessage: {}
};
var mutations = {
  SET_ACTIVE: function SET_ACTIVE(state, index) {
    setSessionStorage("active", index);
    state.active = index;
  },
  SET_ACTIVE_WEAPP: function SET_ACTIVE_WEAPP(state, index) {
    state.activeWeapp = index;
  },
  SET_MINI_MESSAGE: function SET_MINI_MESSAGE(state, obj) {
    if (obj.domain) sessionStorage.setItem("domain", obj.domain || process.env.VUE_APP_BASE_API3);
    state.miniMessage = obj;
  },
  SET_APPLY_MESSAGE: function SET_APPLY_MESSAGE(state, obj) {
    state.applyMessage = obj;
  }
};
var actions = {
  changeSetting: function changeSetting(_ref, data) {
    var commit = _ref.commit;
    commit('CHANGE_SETTING', data);
  },
  getMiniMessage: function () {
    var _getMiniMessage2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(_ref2, data) {
      var commit, res, _getMin, _getMin2;

      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _getMin2 = function _getMin4() {
                _getMin2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                  return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          _context.next = 2;
                          return _getMiniMessage(data.id);

                        case 2:
                          res = _context.sent;
                          if (res.datas.commitCode) res.datas.commitCode.createTime = parseTime(res.datas.commitCode.createTime);
                          res.datas.inUseCode && (res.datas.inUseCode.createTime = parseTime(res.datas.inUseCode.createTime));
                          res.datas.inUseCode && (res.datas.inUseCode.releaseTime = parseTime(res.datas.inUseCode.releaseTime));
                          if (res.datas.commitCode) res.datas.commitCode.errmsg = cleanSpelChar(res.datas.commitCode.errmsg);
                          res.datas.nicknameModifyLog && (res.datas.nicknameModifyLog.createTime = parseTime(res.datas.nicknameModifyLog.createTime));
                          res.datas.systemNewestCode && (res.datas.systemNewestCode.createTime = parseTime(res.datas.systemNewestCode.createTime));
                          res.datas.systemNewestCode && (res.datas.systemNewestCode.userDesc = cleanSpelChar(res.datas.systemNewestCode.userDesc));
                          commit('SET_MINI_MESSAGE', res.datas);

                        case 11:
                        case "end":
                          return _context.stop();
                      }
                    }
                  }, _callee);
                }));
                return _getMin2.apply(this, arguments);
              };

              _getMin = function _getMin3() {
                return _getMin2.apply(this, arguments);
              };

              commit = _ref2.commit;

              if (!(data.type * 1 == 1)) {
                _context2.next = 10;
                break;
              }

              _context2.next = 6;
              return loadH5Info(data.id);

            case 6:
              res = _context2.sent;
              commit('SET_MINI_MESSAGE', res.datas);
              _context2.next = 12;
              break;

            case 10:
              _context2.next = 12;
              return _getMin();

            case 12:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    function getMiniMessage(_x, _x2) {
      return _getMiniMessage2.apply(this, arguments);
    }

    return getMiniMessage;
  }()
};
export default {
  state: state,
  mutations: mutations,
  actions: actions
};